import React from "react";
import { getTypeofWork } from "../../../../../utils/utils";
import { getBackgroundColor } from "../../../../../utils/statusUtils";

const ShiftDetailsTable = ({shift} : any) => {
    const shiftStyle = {
        backgroundColor: getBackgroundColor(shift.shiftStatus)
    };

    const getChristmasShiftColor = (sentence: any): any => {
        const hasXmas = (sentence: string) => sentence.toLowerCase().includes("xmas");

        if (hasXmas(sentence)) {
            return '#ffa8d3ff';
        }

        return '';
    };

    const getHolidayEmoji = (sentence: string): string => {
        const hasXmas = (sentence: string) => sentence.toLowerCase().includes("xmas");

        if (hasXmas(sentence)) {
            return '🎄';
        }
        return '';
    };

    const xmasColor = {
        backgroundColor: getChristmasShiftColor(shift.wp)
    };

    return (
        <div className="shift-details-table" style={shiftStyle}>
            <div className="details-data text-align-right" style={xmasColor}>TEAM NAME:</div>
            <div className="details-data centered" style={xmasColor}>
                {shift.wp} {getHolidayEmoji(shift.wp)}
            </div>
            <div className="details-data text-align-right">
                CLIENT & PROJECT:
            </div>
            <div className="details-data centered">
                {shift.client} - {shift.project}
                {getTypeofWork(shift.region)}
            </div>
            <div className="details-data text-align-right">CLIENT SITE CONTACT:</div>
            <div className="details-data centered">
                {shift.clientSiteContacts}
            </div>
            <div className="details-data text-align-right border-bottom-0">PACE ON CALL:</div>
            <div className="details-data centered border-bottom-0">
                {shift.onCallNumber}
            </div>
        </div>
    )
}

export default ShiftDetailsTable;
